<mat-toolbar (click)="dismissSidebar()">
  <mat-toolbar-row [ngClass]="headerChange ? 'header-height-thin': 'header-height'" fxLayout="row"
    fxLayout.lt-sm="column" fxLayoutAlign="space-between center">

    <div fxLayoutAlign="start center" fxFlex="25">
      <img class="hamburger-menu" src="assets/images/icon-hamburger-menu.png" alt="menu"
        (click)="sideNavBar.toggleSidebar($event)" />
      <img src="assets/images/logo-myinfrastructure.svg" alt="logo" />
    </div>

    <div class="nr-header-wrapper" fxFlex="25" fxLayoutAlign="end center" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex="column" class="header-search" [ngClass]="showSearch ? 'show' : 'hide'" (click)="onSearchPanel()">
          <div class="search-bg" [ngClass]="headerChange ? 'ht-move' : 'ht-fixed' "></div>
          <div class="search-icon"><img alt="expand-search" src="assets/images/search_arrowdown.svg" /></div>
        </div>
      </div>
      <div class="dst-user-details" fxLayout="row" fxLayoutAlign="center center">
        <div fxLayout="row" fxLayoutAlign="center center">
          <button class="drop-toggle" type="button" (click)="hideDropDown($event)" fxlayout="row">
            <div fxLayout="row" fxLayoutAlign="center center">
              <span class="dst-button-icon-username">{{ profilename }}</span>
              <img class="dst-button-icon" alt="" src="assets/images/arrow-down.png" *ngIf="!showDropDown" />
              <img class="dst-button-icon" alt="" src="assets/images/arrow-up.png" *ngIf="showDropDown" />
            </div>
          </button>
          <div class="drop-show" ClickOutside (clickOutside)="hideDropDown($event, true)" *ngIf="showDropDown">
            <label *ngIf="!isReadUser">
              <span class="user-label" (click)="onAlert()"> Reminders & Notifications </span>
            </label>
            <label><span class="user-label" (click)="onSignout()"> Sign Out </span></label>
          </div>
        </div>
        <div fxFlex="20%" fxLayoutAlign="center center">
          <img id="img-avatar" mat-card-avatar [src]='imgProfile' alt="avatar" />
          <!-- <div class="user-count" (click)="onAlert()"><span class="user-count-text">3</span></div> -->
        </div>
      </div>
    </div>

  </mat-toolbar-row>
</mat-toolbar>

<app-sidenavbar #sideNavBar [navMenuOpened]="menuOpened"></app-sidenavbar>

<div [class.hidden]="!showSearch" (click)="dismissSidebar()" class="search-wrapper" fxLayout="row"
  fxLayoutAlign="center center" fxLayoutGap="30" *ngIf="showSearch">
  <form [formGroup]="Search">
    <div class="search-section" fxLayout="row" fxLayoutAlign="center center">
      <div class="failure-input">
        <div class="failure-icon">
          <img src="assets/images/search_criteria.svg" alt="" />
        </div>
        <mat-form-field class="failure">
          <mat-label>Select</mat-label>
          <mat-select formControlName="searchType" id="failure_bgcolor" panelClass="myPanel">
            <mat-option *ngFor="let type of searchTypes" [value]="type">{{type}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="search-input">
        <input id="searchfiltervalue" type="text" placeholder="Search" autocomplete="off"
          formControlName="globalSearch">
      </div>
      <div class="search-filterby">
        <mat-form-field>
          <mat-label>Select</mat-label>
          <mat-select formControlName="fieldSearch" panelClass="myPanel1">
            <mat-option *ngFor="let fieldType of fieldTypes" [value]="fieldType">{{fieldType}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="search-icon" (click)="onSearch()">
        <mat-icon aria-hidden="false" aria-label="search icon" (click)="quickSearch()">search</mat-icon>
      </div>
    </div>
  </form>
  <div class="close-icon" (click)="CloseSearchBar()">
    <mat-icon class="close" aria-hidden="false" aria-label="close icon">close</mat-icon>
  </div>
</div>